import { Avatar, Box, Dialog } from '@material-ui/core';
import React, {
  useState, useContext, useEffect, useRef,
} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Typography from '@avon/component-library/dist/Typography';
import { useError } from '@avon/component-library';
import cookies from 'react-cookies';

import { func } from 'prop-types';
import { useTheme } from '@material-ui/styles';
import avonLogoFooter from '../styles/assets/avon_logo_footer.svg';
import newApptIconWhite from '../styles/assets/new_appointment_white.svg';
import closeSvg from '../styles/assets/close.svg';
import foldSvg from '../styles/assets/fold_arrow.svg';
import cloaseWhiteSvg from '../styles/assets/close_white.svg';
import infoWhiteSvg from '../styles/assets/info.svg';
import logoutSvg from '../styles/assets/logout.svg';
import shareSvg from '../styles/assets/share_black.svg';
import backSvg from '../styles/assets/back.svg';
import LandingPage from '../components/LandingPage';
import Activity from '../components/Activity';
import Help from '../components/Help';
import TC from '../components/TC';
import TaC from '../components/TaC/TaC';
import { OptOut, LearnMore } from '../components/OptOut';
import Notification from '../components/Notification';
import Modal from '../components/Modal';
import NotificationSetting from '../components/NotificationSetting';
import CloseAccount from '../components/CloseAccount';

import HomeContext from './HomeContext';
import getDeviceType, { isDesktop, isMobile, isTablet } from '../utils/getDeviceType';
import formatDate from '../utils/formatDate';
import noop from '../utils/noop';
// eslint-disable-next-line
// import useWebsocket from '../utils/webSocket/webSocket';
import { webSocketInit, subscribeNotification, disconnect } from '../utils/webSocket/webSocket';

import {
  getSlProfile,
  getDashboard,
  getNotificationCount,
  getSSO,
  checkAgreements,
  getTacContent,
  getLoginInfo,
  acceptLegalInfo,
} from '../utils/api/endpoints';
import share from '../utils/share';
import { useTracking } from '../analytics/Analytics';
import getSocialList from '../utils/getSocialList';
import ShareModal from '../components/ShareModal';

const domain = process.env.REACT_APP_API_URL.replace('/appt/rga', '');

const useStyles = makeStyles(theme => ({
  pageContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
  menuContainer:
    // eslint-disable-next-line
    p => (p.deviceType === 'desktop' ? {
      display: 'flex',
      flexDirection: 'column',
      width: 290,
      minWidth: 290,
      height: '100%',
      overflow: 'auto',
    } : p.deviceType === 'tablet' ? {
      display: 'flex',
      flexDirection: 'column',
      width: 380,
      background: '#FFFFFF',
      zIndex: 1000,
      position: 'absolute',
    } : {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      background: '#FFFFFF',
      zIndex: 1000,
      position: 'absolute',
    }),
  menuAvonLogo: {
    marginTop: 32,
    marginLeft: cookies.load('langCd') === 'ar' ? 'unset' : 27,
    marginRight: cookies.load('langCd') === 'ar' ? 27 : 'unset',
    cursor: 'pointer',
    flexShrink: 0,
  },
  menuSlInfo: {
    margin: '24px 24px 0 24px',
    display: 'flex',
    background: '#F6F9F9',
    flexShrink: 0,
  },
  menuAvatar: {
    boxShadow: '0 0px 4px 0 #e1e1e1',
    width: 44,
    height: 44,
    padding: 0,
    transform: 'translateX(1px) translatey(1px)',
  },
  menuContact: {
    width: 150,
    height: 'auto',
    margin: '16px 16px 16px 12px',
  },
  menu: {
    width: '100%',
    cursor: 'pointer',
  },
  menuItem: {
    padding: '18px 24px',
    width: '100%',
    cursor: 'pointer',
  },
  menuHover: {
    '&:hover': {
      color: theme.palette.colors.corePink,
    },
  },
  logout: {
    margin: '18px 24px',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.colors.corePink,
    },
  },
  bodyContainer: {
    flex: 1,
    height: '100%',
    background: '#F6F9F9',
    overflowY: 'hidden',
  },
  bodyHeader: {
    display: 'flex',
    // height: 160,
    background: `linear-gradient(131.14deg, ${theme.palette.colors.corePink} 4.53%, #E2197C 70.61%, #E5231B 102.64%)`,
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    backgroundColor: '#293132',
    width: 'calc(100% - 290px)',
    height: 80,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  footerLink: {
    marginLeft: 64,
  },
  footerAvonLogo: {
    marginRight: 64,
  },
  styledLink: {
    textDecoration: 'none',
    color: theme.palette.colors.zircon,
    fontSize: 12,
    lineHeight: '1',
    marginRight: 48,
  },
  frame: {
    '&::-webkit-scrollbar': {
      width: 2,
    },
  },
  bodyContent:
    // eslint-disable-next-line
    e => (e.deviceType === 'desktop' ? {
      position: 'absolute',
      margin: '0 64px',
      borderRadius: 12,
      height: 'calc(100% - 364px)',
      width: 'calc(100% - 128px - 290px)',
      top: 100,
      zIndex: 999,
      background: '#FFFFFF',
    } : e.deviceType === 'tablet' ? {
      position: 'absolute',
      width: 'calc(100% - 96px)',
      height: 'calc(100% - 242px)',
      margin: '0 48px',
      borderRadius: 8,
      top: 212,
      zIndex: 999,
      background: '#FFFFFF',
    } : {
      position: 'relative',
      height: 'calc(100% - 62px)',
      zIndex: 999,
      background: '#FFFFFF',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    }),
  expirationBanner: {
    position: 'absolute',
    top: 6,
    left: 6,
    zIndex: 1000,
    width: 'calc(100% - 12px)',
    background: '#181818',
    color: '#ffffff',
    height: 48,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 12px',
  },
  logoBox: {
    flexGrow: 1,
    textAlign: 'center',
  },
}));

const links = [
  { label: 'Help & Support', url: '' },
  { label: 'Terms & Conditions', url: '' },
  { label: 'Privacy & Policy', url: '' },
  { label: 'Bad Debt Responsibility', url: '' },
];

const menuSvg = color => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M34 11C34 10.4477 33.5523 10 33 10H15L14.8834 10.0067C14.386 10.0645 14 10.4872 14 11C14 11.5523 14.4477 12 15 12H33L33.1166 11.9933C33.614 11.9355 34 11.5128 34 11ZM10.2636 37.9014V33.3859L12.6075 37.1127H13.1986L15.5424 33.3268L15.5526 37.9014H16.806L16.7959 31H15.7055L12.9234 35.5746L10.0904 31H9V37.9014H10.2636ZM24.082 37.9014V36.8268H20.0567V34.9239H23.5011V33.869H20.0567V32.0746H23.9393V31H18.7319V37.9014H24.082ZM26.8744 33.2282V37.9014H25.5598V31H26.6502L30.5838 35.6732V31H31.8984V37.9014H30.808L26.8744 33.2282ZM36.8817 38C37.8668 38 38.6328 37.7322 39.1797 37.1965C39.7266 36.6608 40 35.8934 40 34.8944V31H38.6956V34.8451C38.6956 36.1991 38.0944 36.8761 36.8919 36.8761C35.6826 36.8761 35.0779 36.1991 35.0779 34.8451V31H33.7532V34.8944C33.7532 35.8934 34.0283 36.6608 34.5786 37.1965C35.1289 37.7322 35.8966 38 36.8817 38ZM33 15C33.5523 15 34 15.4477 34 16C34 16.5128 33.614 16.9355 33.1166 16.9933L33 17H15C14.4477 17 14 16.5523 14 16C14 15.4872 14.386 15.0645 14.8834 15.0067L15 15H33ZM34 21C34 20.4477 33.5523 20 33 20H15L14.8834 20.0067C14.386 20.0645 14 20.4872 14 21C14 21.5523 14.4477 22 15 22H33L33.1166 21.9933C33.614 21.9355 34 21.5128 34 21Z" fill={color} />
  </svg>
);
const notifySvg = color => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12.9933 0.883379C12.9355 0.38604 12.5128 0 12 0C11.4477 0 11 0.447715 11 1V2.05707C6.68457 2.55287 3.33335 6.2184 3.33333 10.6666V14.8462C3.33333 17.0534 2.34585 18 0 18V20H8L8.0049 20.1996C8.10892 22.316 9.8578 24 12 24C14.2091 24 16 22.2091 16 20H24V18C21.6542 18 20.6667 17.0534 20.6667 14.8462V10.6666C20.6666 6.2184 17.3154 2.55287 13 2.05707V1L12.9933 0.883379ZM12 4C8.31811 4 5.33335 6.98476 5.33333 10.6666V14.8462C5.33333 16.0954 5.06595 17.1324 4.55074 17.9408L4.512 18H19.489L19.4493 17.9408C18.9684 17.1863 18.7034 16.2326 18.6702 15.0932L18.6667 14.8462V10.6667C18.6667 6.98476 15.6819 4 12 4ZM12 22C10.8954 22 10 21.1046 10 20H14L13.9945 20.1493C13.9182 21.1841 13.0544 22 12 22Z" fill={color} />
  </svg>
);

const fullScreen = item => ['snsSetting', 'snsConfig'].indexOf(item) !== -1;

const Home = ({ callApi }) => {
  const theme = useTheme();

  const deviceType = getDeviceType();
  const classes = useStyles({ deviceType });
  const [{
    profile, dashboard, currentPage, unreadCount, back,
  }, dispatch] = useContext(HomeContext);
  const [, setTracking] = useTracking();
  const [isSubmitting, setSubmitting] = useState(false);
  const { setError, cleanToastBanner } = useError();
  const [menuItem, setMenuItem] = useState(sessionStorage.getItem('currentPage') || currentPage);
  const [menuCategory, setMenuCategory] = useState();
  const [showFooter, setShowFooter] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const dashboardJSON = JSON.parse(dashboard || sessionStorage.getItem('dashboard'));
  const profieJSON = JSON.parse(profile || sessionStorage.getItem('slProfile'));
  const avatar = profieJSON.files.myPic;
  const [shareOpen, setShareOpen] = useState(false);

  const {
    webMenuInfo,
    logOutInfo,
    dashboardInfo,
    backBtn,
    sharePRPInfo,
    apptFlowHeader,
    changeLanguageInfo = {},
    closeAccount,
  } = dashboardJSON;
  const { categories } = webMenuInfo;
  const { headingWelcome = 'Welcome' } = dashboardInfo;
  const { containerDialog: logoutDialog, sessionExpire } = logOutInfo;
  const { containerDialog: changeLanguageDialog } = changeLanguageInfo;
  const { containerDialog: notPrpDialog } = sharePRPInfo;

  const [logoutModal, setLogoutModal] = useState(false);
  const [notPrpModal, setNotPrpModal] = useState(false);

  const [menuFold, setMenuFold] = useState({});

  const toggleShowMenu = () => setShowMenu(!showMenu);

  const [redirectParams, setRedirectParams] = useState();
  const [expirationBanner, setExpirationBanner] = useState(false);
  const [closeBanner, setCloseBanner] = useState(false);
  const [showBackBtn, setShowBackBtn] = useState(false);
  const [searchHis, setSearchHis] = useState('');

  const timer = useRef(1800);
  const [iframeKey, setIframeKey] = useState(0);
  const mrktCd = cookies.load('mrktCd');
  const langCd = cookies.load('langCd');
  const userAcct = sessionStorage.getItem('userId');

  const [socialList, setSocialList] = useState();
  const [onboardOpen, setOnboardOpen] = React.useState(false);

  const [agrChecks, setAgrChecks] = useState([]);
  const [argFetched, setArgFetched] = useState(false);
  const [agrs, setAgrs] = useState();
  const [loginInfo, setLoginInfo] = useState({});

  const [changeLanguageModal, setChangeLanguageModal] = useState(false);
  const [toLang, setToLang] = useState(langCd);

  const getAgrmntContent = async (type) => {
    try {
      const res = await callApi(getTacContent(type, mrktCd, langCd));

      return res.jsonObject;
    } catch (e) {
      setError(e.error);
      setSubmitting(false);
      return false;
    }
  };

  useEffect(async () => {
    const agreements = await callApi(checkAgreements(mrktCd, langCd));
    setAgrs(agreements);
    setArgFetched(true);

    const getLogin = async () => {
      try {
        const res = await callApi(getLoginInfo());
        return res.jsonObject;
      } catch (e) {
        setError(e.error);
        setSubmitting(false);
        return false;
      }
    };

    // check if any agreement not accepted, then open the TaC modal.
    const checks = agreements.userAgrmntVers.map(e => ({ ...e, checked: false }));
    if (agreements.userAgrmntVers
      && agreements.userAgrmntVers.some(e => e.isLatestVer === false)) {
      setAgrChecks(checks.reverse());

      getLogin().then(resp => setLoginInfo(resp.loginInfo));
    }
  }, []);

  const handleOnboardOpen = () => {
    setOnboardOpen(true);
  };

  const handleOnboardClose = () => {
    setOnboardOpen(false);
  };

  useEffect(() => {
    const findSlProfile = async () => {
      const slProfile = await callApi(getSlProfile());
      const slProfileString = JSON.stringify(slProfile);
      dispatch({
        profile: slProfileString,
      });
      sessionStorage.setItem('slProfile', slProfileString);
      const { mobilePhonNr, emailAddrTxt, socialSharing } = slProfile;
      const tempSocialList = getSocialList(mobilePhonNr, emailAddrTxt, socialSharing);
      setSocialList(tempSocialList);
    };
    findSlProfile();
  }, []);

  useEffect(() => {
    setTracking({
      market: mrktCd,
      language: langCd,
      rep_id: userAcct,
    });
  }, []);

  const getSSOLink = async (authAppType, landingPage) => {
    let link;
    try {
      cleanToastBanner();
      const resp = await callApi(getSSO(authAppType, landingPage));
      const params = resp.params.reduce((ret, param) => `${ret}${ret.length > 0 ? '&' : ''}${param.name}=${param.value}`, '');
      link = `${resp.url}?${params}`;
    } catch ({ error }) {
      setError(error);
    }
    return link;
  };

  // eslint-disable-next-line
  function onShareYourPrp(isPreview) {
    // eslint-disable-next-line
    const mySharePrp = categories.filter(c => c.type === "personalPage")[0].subcategories.filter(sc => sc.type === "mySharePrp")[0];
    const { prpmanLink, previewLink } = mySharePrp;
    if (!profieJSON.vanityName) { // new user -> pre-built
      setMenuCategory([{ ...menuCategory, link: `${previewLink}?accessToken=${sessionStorage.getItem('accessToken')}` }]);
    } else if (!profieJSON.status) { // disabled -> toggle
      setMenuCategory([{ ...menuCategory, link: prpmanLink }]);
    } else if (isPreview) { // enabled -> preview
      const myProfile = categories.filter(c => c.type === 'personalPage')[0].subcategories.filter(sc => sc.type === 'myProfile')[0];
      setMenuCategory([{ ...myProfile }]);
      setRedirectParams(`accessToken=${sessionStorage.getItem('accessToken')}`);
      dispatch({ currentPage: 'myProfile' });
      setMenuItem('myProfile');
    } else { // enabled -> open share modal
      dispatch({ currentPage: 'home' });
      setMenuItem('home');
      sessionStorage.setItem('shareModal', true);
      setShareOpen(true);
    }
  }

  const handleClickMenu = async ({
    type, subType, hasFooter, params, editPrp, entry,
  }) => {
    // lma leads
    if (subType !== 'leads') {
      setSearchHis('');
      sessionStorage.setItem('searchHis', '');
    }
    if (type === 'onboarding') {
      // const win = window.open('http://localhost:3001/onboarding', 'onboarding', 'width=100vh,height=100vh,popup');
      // window.addEventListener('message', (e) => {
      //   if (e.data && e.data.type === 'requireParams') {
      //     console.log(JSON.stringify(e.data));
      //     win.postMessage({
      //       accessToken: sessionStorage.getItem('accessToken'),
      //       userId: userAcct,
      //       mrktCd,
      //       langCd,
      //     }, '*');
      //   } else if (e.data === 'saveAndExit') {
      //     console.log('receive message from iframe:', e.data);
      //     // console.log(JSON.stringify(e.data));
      //     win.close();
      //   }
      // });
      handleOnboardOpen();
    }
    if (type === 'appointment') {
      setTracking({
        event: 'start_appointment',
        market: mrktCd,
        language: langCd,
        rep_id: userAcct,
        refferal: entry,
      });
    }
    setShowBackBtn(false);
    dispatch({ back: 'init' });
    if (type === 'learnMore') {
      await setMenuItem(type);
    } else if (type === 'sso') {
      getSSOLink('MAO', 'login').then((link) => {
        window.open(link, type);
      });
    } else if (type === 'ssoConnector') {
      getSSOLink('CONNECTOR', '').then((link) => {
        window.open(link, type);
      });
    } else {
      if (!categories.filter(c => c.type === type)[0]) {
        // eslint-disable-next-line
        type = subType;
        // eslint-disable-next-line
        subType = null;
      }
      await setMenuCategory(subType === null
        ? categories.filter(c => c.type === type)
        // eslint-disable-next-line
        : categories.filter(c => c.type === type)[0].subcategories.filter(sc => sc.type === subType));

      if (subType === 'myStats') {
        if (!profieJSON.vanityName) {
          setNotPrpModal(true);
          return;
        }
      }
      await setMenuItem(subType === null ? type : subType);

      if (subType === 'myPage') {
        if (editPrp) {
          setMenuCategory([{ ...menuCategory, link: `${editPrp}&accessToken=${sessionStorage.getItem('accessToken')}` }]);
        } else {
          // eslint-disable-next-line
          const myPage = categories.filter(c => c.type === type)[0].subcategories.filter(sc => sc.type === subType)[0];
          const { link, prpPreviewLink } = myPage;
          if (link) {
            share({ url: link });
            setMenuCategory({ ...menuCategory, link: null });
          } else {
            setMenuCategory({ ...menuCategory, link: `${prpPreviewLink}?accessToken=${sessionStorage.getItem('accessToken')}` });
          }
        }
      }

      // handle share
      if (subType === 'mySharePrp') {
        onShareYourPrp();
      }

      if (subType === 'myProfile') {
        await setRedirectParams(`accessToken=${sessionStorage.getItem('accessToken')}&isWebApp=true`);
      } else {
        await setRedirectParams(params);
      }

      // socialList
    }
    setShowFooter(hasFooter);
    setShowMenu(false);
  };

  const getNotificationNumber = async () => {
    if (cookies.load('mrktCd') && cookies.load('langCd')) {
      const { unreadCount: count } = await callApi(getNotificationCount());
      dispatch({ unreadCount: count });
    }
  };

  const desktopNotification = ({ content, header } = { content: 'content', header: 'title' }) => {
    if (!('Notification' in window)) {
      alert('This browser does not support desktop notification');
      return;
    }
    // eslint-disable-next-line
    const H5Notification = window.Notification || window.mozNotification || window.webkitNotification;
    if (H5Notification.permission !== 'denied') {
      H5Notification.requestPermission((status) => {
        if (status === 'granted') {
          const notification = new H5Notification(header, {
            body: content,
            icon: avatar,
          });
          notification.onclick = function () {
            if (currentPage !== 'snsSetting') {
              dispatch({ currentPage: 'snsSetting' });
              handleClickMenu({
                type: 'snsSetting', subType: null, hasFooter: false, params: null,
              });
            }
            window.focus();
            notification.close();
          };
        }
      });
    }
  };

  const [wsData, setWsData] = useState();
  useEffect(() => {
    // eslint-disable-next-line
    const H5Notification = window.Notification || window.mozNotification || window.webkitNotification;
    if (H5Notification && H5Notification.permission !== 'denied') {
      H5Notification.requestPermission();
    }

    const initWebSocketConnect = async () => {
      await webSocketInit();
      subscribeNotification(({ body }) => {
        // eslint-disable-next-line
        const dataBody = body && JSON.parse(body) || {};
        desktopNotification(dataBody);
        setWsData(dataBody);
        getNotificationNumber();
      });
    };
    initWebSocketConnect();
  }, []);

  const avonLogo = (
    <svg width="111" height="24" viewBox="0 0 111 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M96.9665 1.51325V15.1041L85.0001 1.51325H81.4537V22.8605H86.0526V9.26964L98.019 22.8605H101.565V1.51325H96.9665ZM10.7081 1.51325L0.366211 22.8605H5.14818L7.34468 18.0785C7.91668 17.987 8.48869 17.987 9.06069 17.8955C9.54118 17.8955 10.1132 17.804 10.5937 17.804C11.6462 17.804 12.6071 17.8955 13.4766 18.1014C14.346 18.2844 15.1926 18.5819 15.879 18.9709C16.634 19.4513 17.2289 19.9318 17.8925 20.5953C18.4645 21.2589 19.0365 21.9453 19.6085 22.8834H24.3904L14.0715 1.51325H10.7081ZM14.163 14.6236C13.2935 14.4406 12.241 14.3262 11.0055 14.3262C10.4335 14.3262 9.76998 14.3262 9.08357 14.4177L12.3326 7.14178L16.3595 15.6532C15.7875 15.1956 15.1239 14.9211 14.163 14.6236ZM35.6017 16.3625L28.8978 1.51325H23.7269L33.7942 22.8605H37.1347L47.3851 1.51325H42.3056L35.6017 16.3625ZM71.1118 3.91567C70.0593 2.86318 68.7094 2.10813 67.1764 1.51325C65.735 0.941242 64.019 0.643799 62.3029 0.643799C60.5869 0.643799 58.9624 0.941242 57.4295 1.51325C55.8965 2.08525 54.661 2.86318 53.4941 3.91567C52.4416 4.96816 51.5721 6.11217 50.9086 7.55362C50.2451 8.99508 49.9476 10.4365 49.9476 12.061C49.9476 13.6855 50.2451 15.2185 50.9086 16.6599C51.5721 18.1014 52.4416 19.2454 53.4941 20.2979C54.5466 21.3504 55.8965 22.1054 57.4295 22.7003C58.9624 23.2952 60.5869 23.5698 62.3029 23.5698C64.019 23.5698 65.6435 23.2723 67.1764 22.7003C68.7094 22.1283 69.9449 21.2589 71.1118 20.2979C72.1643 19.2454 73.0338 18.0099 73.6973 16.6599C74.3608 15.2185 74.6583 13.777 74.6583 12.061C74.6583 10.4365 74.3608 8.90356 73.6973 7.55362C73.0338 6.20369 72.1643 4.96816 71.1118 3.91567ZM69.3043 15.1956C68.9153 16.1566 68.4349 16.9116 67.7713 17.598C67.1078 18.2616 66.3299 18.742 65.3689 19.2225C64.4079 19.6115 63.447 19.7945 62.3029 19.7945C61.2505 19.7945 60.198 19.6115 59.237 19.2225C58.276 18.8336 57.521 18.3531 56.8346 17.598C56.1711 16.9345 55.6906 16.1566 55.3016 15.1956C54.9126 14.2346 54.7296 13.2737 54.7296 12.1297C54.7296 11.0772 54.9126 10.0247 55.3016 9.15524C55.6906 8.28579 56.1711 7.43922 56.8346 6.75282C57.4981 6.08929 58.276 5.60881 59.237 5.21984C60.198 4.83088 61.1589 4.64784 62.3029 4.64784C63.3554 4.64784 64.4079 4.83088 65.3689 5.21984C66.3299 5.60881 67.0849 6.08929 67.7713 6.75282C68.4349 7.41634 68.9153 8.19427 69.3043 9.15524C69.6933 10.0247 69.8763 11.0772 69.8763 12.1297C69.8763 13.1822 69.6933 14.2575 69.3043 15.1956Z" fill="#E5004B" />
      <defs>
        <linearGradient id="paint0_linear" x1="-52.2657" y1="16.0066" x2="-39.903" y2="63.2636" gradientUnits="userSpaceOnUse">
          <stop stopColor={theme.palette.colors.corePink} />
          <stop offset="0.673591" stopColor="#E2197C" />
          <stop offset="1" stopColor="#E5231B" />
        </linearGradient>
      </defs>
    </svg>
  );
  const justineLogo = (size, color) => (
    <svg width="141" height={size} viewBox="0 0 141 58" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M139.723 32.0702C130.364 40.609 126.439 40.2476 123.416 38.686C122.129 38.0815 121.831 35.9674 123.615 34.6595C132.222 29.0855 134.084 18.0241 123.283 25.0565C121.001 26.598 117.865 30.0873 116.612 36.3714C107.908 39.9005 107.607 37.2619 108.593 32.172C111.224 24.3497 109.31 23.4361 102.855 29.4278C101.444 27.9519 100.357 28.0712 98.6341 29.7709L91.2069 35.5148C84.1317 40.1167 82.8195 39.049 86.4054 32.0462C89.832 26.7848 89.3294 24.7377 83.7787 30.0285C83.2787 30.9249 82.8209 31.7726 82.3928 32.5848C67.8998 46.1704 69.6049 38.3271 80.307 18.7961C106.334 17.6777 134.945 16.6457 134.945 16.6457L136.272 13.4037C136.272 13.4037 107.477 13.8772 84.6222 14.5093C81.1618 14.7658 82.2049 14.5131 84.0188 10.9075C86.1615 6.58314 84.7675 5.79074 82.4279 7.30718C81.0715 8.02606 80.6222 9.74727 79.7267 11.6795C79.1085 13.4073 78.4338 14.2645 77.7012 14.2514L62.7163 14.671L60.6522 19.3107C67.591 18.349 72.0566 18.2621 76.3561 18.5938L67.9111 36.5435C64.1244 46.9961 68.3585 48.9594 79.8419 37.9208C76.2598 46.6102 80.1566 46.5274 91.5441 37.6602C94.5936 35.3027 95.3503 35.8184 93.8229 39.2015C92.9949 41.5168 94.0189 44.0574 96.0926 41.8403L98.9659 37.944C102.174 34.0844 102.582 33.9281 102.498 38.5572C102.805 43.3791 107.303 44.5925 113.322 41.3439C115.569 40.0894 116.375 39.2396 117.643 40.9853C123.313 46.5868 133.311 43.6449 140.485 33.1844C141.118 31.5389 140.864 31.1662 139.723 32.0702ZM122.351 30.0285L123.872 27.2848C124.884 25.8269 126.235 27.1127 125.391 29.1705L124.545 30.285C123.028 32.9426 121.733 32.3999 122.351 30.0285ZM58.178 24.9582C56.5147 26.9923 55.9861 28.2719 55.9151 29.443C55.7266 30.4661 56.1403 30.1516 54.8144 31.0518L51.3283 33.579C41.3425 41.3134 40.5522 38.0537 48.2933 26.0164C49.4623 23.6425 44.4906 25.5165 41.5567 28.5689C41.1318 31.2212 39.8381 33.4499 37.673 35.2588C33.6939 39.2015 31.4955 38.8739 33.6939 34.4003L36.66 28.0557C38.3544 24.6301 37.5047 24.2718 33.525 26.8556C31.2127 28.243 31.1551 28.5458 29.9807 31.6568L26.2657 40.5736C25.0087 44.126 26.7391 44.697 30.2456 42.6322L34.4657 40.06C37.3283 37.7101 38.4533 37.9391 37.8424 40.7454C37.7658 44.1277 41.6207 44.6371 45.7762 42.1178L51.8802 36.1237C54.1435 33.8505 56.0681 32.953 57.6157 34.5639C59.3905 35.9654 60.255 37.5184 60.6319 38.8586C61.1833 40.228 59.9955 42.2014 58.4378 40.5736C58.2451 38.9259 57.3272 38.9441 55.7363 40.2318C54.7351 40.9167 54.0263 41.5005 54.0472 43.1457C54.3467 46.0008 56.5989 45.8859 60.8008 42.8043C67.7478 37.6504 68.649 33.4774 63.5025 30.285C61.3095 28.9627 60.9753 28.109 63.3331 26.1683C66.4858 23.4557 63.2294 19.98 58.178 24.9582ZM39.0806 0L33.1594 0.697634C31.8703 0.885793 31.0741 0.944066 30.8509 2.51115C25.4478 24.4782 23.1757 44.1464 0 58C29.4829 49.9965 39.0806 0 39.0806 0Z" fill={color} />
    </svg>
  );

  const newApptIcon = (
    <svg width="92" height="96" viewBox="0 0 92 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <path fillRule="evenodd" clipRule="evenodd" d="M48 66C63.464 66 76 53.464 76 38C76 22.536 63.464 10 48 10C32.536 10 20 22.536 20 38C20 53.464 32.536 66 48 66Z" fill="url(#paint0_linear)" />
        <path d="M75.5 38C75.5 53.1878 63.1878 65.5 48 65.5C32.8122 65.5 20.5 53.1878 20.5 38C20.5 22.8122 32.8122 10.5 48 10.5C63.1878 10.5 75.5 22.8122 75.5 38Z" stroke="white" strokeOpacity="0.16" />
      </g>
      <path fillRule="evenodd" clipRule="evenodd" d="M48.9933 31.8834C48.9355 31.386 48.5128 31 48 31C47.4477 31 47 31.4477 47 32V37H42L41.8834 37.0067C41.386 37.0645 41 37.4872 41 38C41 38.5523 41.4477 39 42 39H47V44L47.0067 44.1166C47.0645 44.614 47.4872 45 48 45C48.5523 45 49 44.5523 49 44V39H54L54.1166 38.9933C54.614 38.9355 55 38.5128 55 38C55 37.4477 54.5523 37 54 37H49V32L48.9933 31.8834Z" fill="white" />
      <defs>
        <filter id="filter0_d" x="0" y="0" width="96" height="96" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <linearGradient id="paint0_linear" x1="-8" y1="38" x2="48" y2="94" gradientUnits="userSpaceOnUse">
          <stop stopColor={theme.palette.colors.corePink} />
          <stop offset="0.673591" stopColor="#E2197C" />
          <stop offset="1" stopColor="#E5231B" />
        </linearGradient>
      </defs>
    </svg>
  );

  const handleMouseMove = () => {
    // eslint-disable-next-line
    if (timer.current > 600) {
      timer.current = 1800;
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleMouseMove, true);

    const timerInterval = setInterval(() => {
      timer.current -= 1;
      if (timer.current <= 600 && (!expirationBanner) && !closeBanner) {
        setExpirationBanner(true);
      }
      if (timer.current === 0) {
        sessionStorage.clear();
        localStorage.clear();
        const { loginPageToast, loginPageToastDesktop } = sessionExpire || {};
        sessionStorage.setItem('sessionExpired', JSON.stringify({
          loginPageToast: loginPageToast || 'Your session has expired due to inactivity.',
          loginPageToastDesktop: loginPageToastDesktop || 'Your session has expired due to inactivity. If you want to navigate into Avon Grow app you need to Login again.',
        }));
        window.location.reload();
      }
    }, 1000);

    return () => {
      clearInterval(timerInterval);
      document.removeEventListener('click', handleMouseMove);
    };
  });

  const componentsMap = {
    landingPage: {
      component: <LandingPage callApi={callApi} setMenuItem={setMenuItem} />,
      showFooter: false,
    },
    home: {
      component: <Activity
        callApi={callApi}
        redirectTo={handleClickMenu}
        setShowBackBtn={setShowBackBtn}
        onShareYourPrp={onShareYourPrp}
      />,
      showFooter: false,
    },
    snsSetting: {
      // eslint-disable-next-line
      component:
  <Notification
    callApi={callApi}
    redirectTo={handleClickMenu}
    setMenuItem={setMenuItem}
    wsData={wsData}
  />,
      showFooter: false,
    },
    snsConfig: {
      component: <NotificationSetting callApi={callApi} setMenuItem={setMenuItem} />,
      showFooter: false,
    },
    help: {
      component: <Help callApi={callApi} />,
      showFooter: false,
    },
    closeAccount: {
      component:
  <CloseAccount
    callApi={callApi}
    config={closeAccount}
    redirectTo={handleClickMenu}
  />,
      showFooter: false,
    },
    termsService: {
      component: <TC callApi={callApi} key="termsService" type="wxTermsService" redirectTo={handleClickMenu} />,
      showFooter: false,
    },
    privacyPolicy: {
      component: <TC callApi={callApi} key="privacyPolicy" type="wxPrivacyPolicy" redirectTo={handleClickMenu} />,
      showFooter: false,
    },
    badDebt: {
      component: <TC callApi={callApi} key="badDebt" type="webBadDebt" redirectTo={handleClickMenu} />,
      showFooter: false,
    },
    optLeads: {
      component: <OptOut callApi={callApi} redirectTo={handleClickMenu} />,
      showFooter: false,
    },
    learnMore: {
      component: <LearnMore callApi={callApi} redirectTo={handleClickMenu} />,
      showFooter: false,
    },
  };

  const refreshDashboardAndProfile = async () => {
    await callApi(getSlProfile()).then((slProfile) => {
      sessionStorage.setItem('slProfile', JSON.stringify(slProfile));
      dispatch({ profile: JSON.stringify(slProfile) });
    });
    await callApi(getDashboard(sessionStorage.getItem('userId'))).then((dashboardData) => {
      sessionStorage.setItem('dashboard', JSON.stringify(dashboardData.jsonObject));
      dispatch({ dashboard: JSON.stringify(dashboardData.jsonObject) });
    });
  };

  useEffect(() => {
    sessionStorage.setItem('currentPage', menuItem);
    setShowFooter(componentsMap[menuItem] ? componentsMap[menuItem].showFooter : false);
    if (currentPage !== 'leads') {
      setShowBackBtn(false);
      setSearchHis('');
    }
  }, [menuItem, currentPage, shareOpen]);

  useEffect(() => {
    getNotificationNumber();
    window.addEventListener('message', (e) => {
      if (e.data === 'saveAndExit') {
        handleOnboardClose();
      } else if (e.data === 'profileUpdated') {
        refreshDashboardAndProfile();
      } else if (e.data === 'backHome') {
        dispatch({ currentPage: 'home' });
        handleClickMenu({
          type: 'home', subType: null, hasFooter: false, params: '',
        });
      } else if (e.data === 'showBackBtn') {
        setShowBackBtn(true);
      } else if (e.data === 'sharePrp') {
        onShareYourPrp();
      } else if (e.data.search) {
        if (typeof e.data.search === 'string') {
          setSearchHis(e.data.search);
        }
      } else if (e.data && e.data.menu) {
        setMenuItem(e.data.menu);
        if (e.data.subMenu) {
          setMenuItem(e.data.subMenu);
        }
        if (e.data.params) {
          setRedirectParams(e.data.params);
        }
        if (!categories.filter(c => c.type === e.data.menu)[0]) {
          // eslint-disable-next-line
          e.data.menu = e.data.subMenu;
          // eslint-disable-next-line
          e.data.subMenu = null;
        }
        setMenuCategory((e.data.subMenu === null || e.data.subMenu === undefined)
          ? categories.filter(c => c.type === e.data.menu)
          // eslint-disable-next-line
          : categories.filter(c => c.type === e.data.menu)[0].subcategories.filter(sc => sc.type === e.data.subMenu));
      } else if (e.data && e.data.type === 'uploadImage') {
        dispatch({
          profile: JSON.stringify({
            ...profieJSON,
            files: {
              myPic: e.data.url,
            },
          }),
        });
      }
    });
  }, []);

  const mobileHeader = () => (
    <Box style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#FFFFFF',
    }}
    >
      <Box m="4px" onClick={toggleShowMenu}>{menuSvg('#181818')}</Box>
      <Box
        className={classes.logoBox}
        onClick={() => {
          dispatch({ currentPage: 'home' });
          handleClickMenu({
            type: 'home', subType: null, hasFooter: false, params: null,
          });
        }}
      >
        {mrktCd === 'JT' ? justineLogo('32px', theme.palette.colors.corePink) : avonLogo}
      </Box>
      <Box
        m="12px"
        position="relative"
        onClick={
          () => {
            dispatch({ currentPage: 'snsSetting' });
            handleClickMenu({
              type: 'snsSetting', subType: null, hasFooter: false, params: null,
            });
          }}
      >
        {notifySvg('#181818')}
        {
          unreadCount > 0 && (
            <span style={{
              position: 'absolute',
              top: -6,
              left: 6,
              padding: '3px 5px',
              background: theme.palette.colors.corePink,
              borderRadius: '10px',
              color: '#ffffff',
              fontSize: 12,
              lineHeight: '12px',
              fontFamily: 'Montserrat',
              fontWeight: 500,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            >
              {unreadCount > 10 ? '10+' : unreadCount}
            </span>
          )
        }
      </Box>
    </Box>
  );

  const changeLanguage = async () => {
    try {
      cleanToastBanner();
      setSubmitting(true);
      sessionStorage.setItem('currentPage', 'home');
      await cookies.save('langCd', toLang, { path: '/' });
      await callApi(getSlProfile()).then(slProfile => sessionStorage.setItem('slProfile', JSON.stringify(slProfile)));
      await callApi(getDashboard(sessionStorage.getItem('userId'), mrktCd, toLang)).then(dashboardData => sessionStorage.setItem('dashboard', JSON.stringify(dashboardData.jsonObject)));
      setSubmitting(false);
      const { origin, pathname } = window.location;
      window.location.href = origin + pathname.replace(`/${langCd}`, `/${toLang}`);
      return true;
    } catch (error) {
      setError(error);
      setSubmitting(false);
      return false;
    }
  };

  const mbAvonSvg = (
    <svg width="74" height="16" viewBox="0 0 74 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M40.5841 7.99375C40.5841 10.7616 42.8456 13.0135 45.6255 13.0135C48.409 13.0135 50.6736 10.7616 50.6736 7.99375C50.6736 5.22217 48.409 2.96757 45.6255 2.96757C42.8456 2.96757 40.5841 5.22217 40.5841 7.99375ZM45.6254 0C47.8882 0 49.8857 0.790586 51.4029 2.28682C52.951 3.79179 53.806 5.81979 53.806 7.99381C53.806 10.1668 52.9484 12.1816 51.3905 13.6679C49.8556 15.1695 47.806 15.9999 45.6254 15.9999C43.4108 15.9999 41.4126 15.1913 39.8472 13.6615C38.3121 12.1525 37.4674 10.1399 37.4674 7.99381C37.4674 5.8171 38.3121 3.79011 39.8465 2.28548C41.3762 0.789914 43.3741 0 45.6254 0ZM10.9505 0.798087H9.34352L2 15.9999H3.77895C4.66694 15.9999 5.43286 15.5533 5.95792 14.6649L7.50124 11.6274C10.2423 11.9696 12.677 13.0018 14.8668 15.9999H18.3118L10.9505 0.798087ZM10.1531 6.02227L12.1014 10.1972C11.0299 9.68074 9.89482 9.30222 8.72461 9.076L10.1531 6.02227ZM26.3028 15.9996L19.1476 0.798454H21.0919C21.9796 0.798454 22.7875 1.32004 23.1646 2.13678L27.0972 10.653L30.9994 2.14245C31.3751 1.32271 32.1847 0.798454 33.0746 0.798454H35.0337L27.8806 15.9996H26.3028ZM70.5425 0.798087C69.6562 0.798087 68.9378 1.51548 68.9387 2.39963L68.9478 10.4186L60.9898 0.798421H58.6294L58.6292 0.798087V15.9999H60.0864C60.9728 15.9999 61.6913 15.2829 61.6903 14.3984L61.6816 6.39581L68.2052 14.3087C68.2052 14.3087 69.482 15.9996 71.3473 15.9996H71.9996L71.9999 15.9999V0.798087H70.5425Z" fill="white" />
    </svg>
  );

  const IframeModal = (
    <Dialog
      open={onboardOpen}
      onClose={handleOnboardClose}
      aria-labelledby="simple-modal-title"
      fullScreen
    // classes={{ root: classes.iframeModal }}
    >
      <iframe
        onLoad={() => {
          const frameOnborad = document.querySelector('#onboarding');
          if (frameOnborad && frameOnborad.contentWindow) {
            frameOnborad.contentWindow.postMessage({
              accessToken: sessionStorage.getItem('accessToken'),
              // acctNr: 'acctNr',
              userId: userAcct,
              // source: 'web Experience',
              mrktCd,
              langCd,
            }, '*');
          }
        }}
        id="onboarding"
        key="onboarding"
        width="100%"
        height="100%"
        frameBorder="0"
        title="iframe"
        scrolling="auto"
        // src='http://localhost:3001/onboarding'
        src="https://arpqa.avon.com/onboarding"
      />
    </Dialog>
  );

  const menuItems = (
    webMenuInfo.categories.filter(e => e.active === true).map((e, index) => (
      <>
        <Box key={`menuItem-${index}`} style={{ display: 'flex' }}>
          <Box width="4px" height="36px" style={{ margin: '12px 0', background: (menuItem === e.type && !(e.subcategories && e.subcategories.length) > 0) ? theme.palette.colors.corePink : 'unset' }} id={`actived-${index}`} />
          <Box
            className={classes.menu}
            onClick={(e.subcategories && e.subcategories.length > 0)
              // eslint-disable-next-line
              ? () => setMenuFold({ ...menuFold, [e.type]: (menuFold[e.type] ? !menuFold[e.type] : true) })
              : () => {
                if (isSubmitting) return false;
                handleClickMenu({
                  type: e.type,
                  subType: null,
                  hasFooter: false,
                  params: null,
                  editPrp: null,
                  entry: 'menu',
                });
                return true;
              }}
          >
            <Box
              style={{ display: 'flex', justifyContent: 'space-between', height: 60 }}
              className={`${classes.menuHover} ${classes.menuItem}`}
            >
              <Box style={{ display: 'flex', alignItems: 'center', height: 24 }}>
                <Typography
                  id={e.type}
                  style={{ fontSize: 16, lineHeight: '24px' }}
                >
                  {e.name}
                </Typography>
              </Box>
              {
                e.type === 'snsSetting' && Number(unreadCount) !== 0 && (
                  <Box>
                    <span style={{
                      marginLeft: 10,
                      padding: '4px 10px',
                      background: theme.palette.colors.corePink,
                      borderRadius: '10px',
                      color: '#ffffff',
                      fontSize: 12,
                      lineHeight: '12px',
                      fontFamily: 'Montserrat',
                      fontWeight: 500,
                    }}
                    >
                      {unreadCount > 10 ? '10+' : unreadCount}
                    </span>
                  </Box>
                )
              }
              {(e.subcategories && e.subcategories.length > 0)
                && (
                  <Box>
                    <img
                      alt="arrow-fold"
                      src={foldSvg}
                      style={{ transform: !menuFold[e.type] ? '' : 'rotateZ(180deg)' }}
                    />
                  </Box>
                )}
            </Box>
            {menuFold[e.type] && e.subcategories
              && e.subcategories.filter(se => se.active === true).map((se, idx) => (
                <Box key={`menu-subitem-${idx}`} style={{ display: 'flex', padding: '0 18px' }} className={classes.menuHover}>
                  <Box
                    width="4px"
                    height="36px"
                    style={{
                      margin: '12px 0', transform: langCd === 'ar' ? 'translateX(22px)' : 'translateX(-22px)', background: menuItem === se.type ? theme.palette.colors.corePink : 'unset',
                    }}
                    id={`actvied-sub-${idx}`}
                  />
                  <Box
                    className={classes.menuItem}
                    onClick={(se.subcategories && se.subcategories.length > 0)
                      ? noop
                      : async (event) => {
                        event.stopPropagation();
                        if (e.type === 'changeLanguage') {
                          if (se.type !== cookies.load('langCd')) {
                            if (isSubmitting || se.isBold) return false;
                            setToLang(se.type);
                            setChangeLanguageModal(true);
                          }
                        } else {
                          handleClickMenu({
                            type: e.type,
                            subType: se.type,
                            hasFooter: false,
                            params: null,
                          });
                          setIframeKey(iframeKey + 1);
                        }
                        return true;
                      }}
                  >
                    <Box className={classes.menuHover}>
                      <Typography
                        variant="body2"
                        id={se.type}
                        style={{
                          fontSize: 16,
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          fontWeight: se.isBold ? 'bold' : 'unset',
                        }}
                      >
                        {se.type === 'mySharePrp' ? se.name || 'Share PRP' : se.name}
                        {
                          // vantiname === ''; new user
                          // status === false;
                          se.type === 'mySharePrp' && (
                            <Box style={{
                              width: 24,
                              height: 24,
                            }}
                            >
                              <img
                                src={shareSvg}
                                alt="share-icon"
                                style={{
                                  width: '100%',
                                  height: '100%',
                                }}
                              />
                            </Box>
                          )
                        }
                        {
                          e.type === 'changeLanguage' && (
                            <div style={{
                              width: 28,
                              height: 20,
                              background: `url(${categories.filter(m => m.type === 'changeLanguage')[0].subcategories.filter(sm => sm.type === se.type)[0].link})`,
                              backgroundRepeat: 'no-repeat',
                              backgroundSize: '100% 100%',
                            }}
                            />
                          )
                        }
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
          </Box>
        </Box>
        {index !== 1 && (
          <div
            id={`divider-${index}`}
            style={{
              height: 1,
              background: 'rgba(0, 0, 0, 0.0784314)',
              margin: '0 24px',
            }}
          />
        )}
      </>
    ))
  );

  const menuComp = (
    (isDesktop() || showMenu) && (
      <Box className={classes.menuContainer}>
        {!isDesktop() && (
          <Box mt="6px" mr="16px" textAlign="right" onClick={toggleShowMenu}>
            <img
              alt="close-menu"
              src={closeSvg}
            />
          </Box>
        )}
        {!isMobile() && (
          <Box
            className={classes.menuAvonLogo}
            onClick={() => {
              dispatch({ currentPage: 'home' });
              handleClickMenu({
                type: 'home', subType: null, hasFooter: false, params: null,
              });
            }}
          >
            {mrktCd === 'JT' ? justineLogo('39px', theme.palette.colors.corePink) : avonLogo}
          </Box>
        )}
        <Box className={classes.menuSlInfo}>
          <Box
            mt="16px"
            ml="16px"
            style={{
              width: 48, height: 48, borderRadius: 24, border: `solid 1px ${theme.palette.colors.corePink}`,
            }}
          >
            <Avatar
              className={classes.menuAvatar}
              src={avatar}
              alt="avatar"
            />
          </Box>
          <Box className={classes.menuContact}>
            <Typography variant="body2" noWrap style={{ fontSize: 16 }}>{webMenuInfo.name}</Typography>
            <Typography
              variant="body2"
              style={{
                fontSize: 12, marginTop: 2, marginBottom: 2, whiteSpace: 'normal',
              }}
            >
              {webMenuInfo.campaignMessage}
            </Typography>
          </Box>
        </Box>

        <Box>
          {menuItems}
        </Box>

        <Box id="logout" className={classes.logout}>
          <Box style={{ display: 'flex' }} onClick={() => setLogoutModal(true)}>
            <Typography variant="body2" style={{ fontSize: 16, flexGrow: 1 }}>{logOutInfo.name || 'Log out'}</Typography>
            <Box><img alt="logout" src={logoutSvg} /></Box>
          </Box>
        </Box>
      </Box>
    )
  );

  const bodyHeaderSvg = (
    <svg width="103" height="86" viewBox="0 0 103 86" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M27.3583 85.8859V85.8862H18.2913V85.8859H18.2912V76.8189H18.2913V58.4854L12.3858 61.8949C8.04909 64.3987 2.50379 62.9128 0 58.5762L18.2913 48.0157V-7.57227C23.2989 -7.57227 27.3583 -3.51283 27.3583 1.49475V42.7808L38.803 36.1732C40.2704 35.326 41.8762 34.9356 43.4558 34.9579C45.0318 34.9375 46.6335 35.3281 48.0976 36.1734L66.4832 46.7883L86.2215 30.2259L67.495 28.5875C70.3182 23.4875 75.9593 20.2524 82.1409 20.7932L87.115 21.2284C95.4865 21.9608 101.679 29.3411 100.947 37.7127L100.512 42.6867C99.9764 48.8053 95.8899 53.7601 90.4607 55.6978L92.0841 37.1428L72.406 53.6546C71.0163 54.8207 69.3795 55.4987 67.704 55.7068C65.7539 55.9935 63.6969 55.6493 61.8573 54.5873L43.4502 43.9599L27.3583 53.2505V76.8189H93.9334C98.9409 76.8189 103 80.8783 103 85.8859H27.3583ZM92.639 30.7996L92.6401 30.7874L92.6279 30.7864L92.639 30.7996Z" fill="white" />
    </svg>
  );

  const getLocalDebugPort = (prjName) => {
    switch (prjName) {
      case 'appointment':
        return '3002';
      case 'myProfile':
        return '3003';
      case 'leads':
        return '3001';
      // case 'myPage':
      //   return '3001';
      // case 'myStats':
      //   return '3001';
      default:
        return '3001';
    }
  };

  const mainPage = (
    <Box className={classes.pageContainer}>
      {mrktCd === 'UK' ? IframeModal : null}
      {menuComp}

      <Box className={classes.bodyContainer}>
        {isMobile() ? (mobileHeader()) : (
          <Box
            id="bodyHeader"
            className={classes.bodyHeader}
            style={{
              display: 'flex',
              flexDirection: isTablet() ? 'column' : 'unset',
              width: '100%',
              height: isTablet() ? 244 : 160,
            }}
          >
            {isTablet() && (
              <>
                <Box style={{
                  height: 52,
                  width: '100%',
                  display: 'flex',
                }}
                >
                  <Box m="4px" onClick={toggleShowMenu}>{menuSvg('#FFFFFF')}</Box>
                  <Box
                    mt="20px"
                    mb="20px"
                    style={{
                      flexGrow: 1, textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}
                    onClick={() => {
                      setMenuItem('home');
                      sessionStorage.setItem('currentPage', 'home');
                      window.location.reload();
                    }}
                  >
                    {mrktCd === 'JT' ? justineLogo('39px', '#FFF') : mbAvonSvg}
                  </Box>
                  <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Box
                      onClick={
                        () => {
                          dispatch({ currentPage: 'appointment' });
                          handleClickMenu({
                            type: 'appointment', subType: null, hasFooter: false, params: null, editPrp: null, entry: 'top_plus_button',
                          });
                        }}
                    >
                      <img
                        alt="newApptWhite"
                        src={newApptIconWhite}
                      />
                    </Box>
                    <div style={{
                      margin: '0px 6px', height: 40, width: 0, border: '1px solid #FFFFFF', opacity: 0.09,
                    }}
                    />
                    <Box
                      m="18px"
                      position="relative"
                      onClick={
                        () => {
                          dispatch({ currentPage: 'snsSetting' });
                          handleClickMenu({
                            type: 'snsSetting', subType: null, hasFooter: false, params: null,
                          });
                        }}
                    >
                      {notifySvg('#FFFFFF')}
                      {
                        unreadCount > 0 && (
                          <span style={{
                            position: 'absolute',
                            top: -6,
                            left: 6,
                            padding: '4px 5px',
                            background: theme.palette.colors.corePink,
                            borderRadius: '10px',
                            color: '#ffffff',
                            fontSize: 12,
                            lineHeight: '12px',
                            fontFamily: 'Montserrat',
                            fontWeight: 500,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                          >
                            {unreadCount > 10 ? '10+' : unreadCount}
                          </span>
                        )
                      }
                    </Box>
                  </Box>
                </Box>
                <div style={{ height: 3, opacity: 0.09, background: '#E4EDED' }} />
              </>
            )}
            <Box style={{
              display: 'flex',
              flexDirection: isTablet() ? 'column' : 'row',
              justifyContent: 'space-between',
              width: isDesktop() ? window.innerWidth - 290 : window.innerWidth,
              maxHeight: 190,
              whiteSpace: 'nowrap',
            }}
            >
              <Box
                id="nav-back"
                style={{
                  display: isDesktop() ? 'none' : 'flex',
                  alignItems: 'center',
                  visibility: 'visible',
                  marginTop: 48,
                  width: 116,
                  height: 24,
                  marginLeft: 64,
                  marginBottom: 2,
                  color: '#ffffff',
                  fontFamily: 'Montserrat',
                  fontWeight: 700,
                  fontSize: 14,
                }}
                onClick={
                  () => {
                    dispatch({ back: 'init' });
                  }
                }
              >
                <Box style={{
                  width: 24,
                  height: 24,
                }}
                >
                  {
                    back !== 'init' && <img src={backSvg} alt="back-icon" />
                  }
                </Box>
                <Box ml={3}>{backBtn ? backBtn[back] : ''}</Box>
              </Box>
              <Box style={{
                width: 'calc(100% - 64px)',
                position: 'relative',
                paddingLeft: langCd === 'ar' ? 'unset' : 64,
                paddingRight: langCd === 'ar' ? 64 : 'unset',
                top: isTablet() ? 2 : 0,
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column',
                alignContent: 'flex-start',
                justifyContent: 'center',
              }}
              >
                <Box
                  style={{
                    textTransform: 'uppercase',
                    fontSize: 14,
                    fontWeight: 'bold',
                    lineHeight: '20px',
                    color: '#fff',
                    visibility: showBackBtn ? 'unset' : 'hidden',
                    display: 'flex',
                    cursor: 'pointer',
                    alignItems: 'center',
                    marginTop: isTablet() ? 0 : 24,
                    position: isTablet() ? 'relative' : 'unset',
                    top: isTablet() ? -40 : 'unset',
                  }}
                  onClick={
                    () => {
                      handleClickMenu({
                        type: 'lma', subType: 'leads', hasFooter: false, params: null,
                      });
                      // handleClickMenu(
                      //   menuItem === 'appointment'
                      //     ? {
                      //       type: 'home', subType: null, hasFooter: false, params: null,
                      //     }
                      //     : {
                      //       type: 'lma', subType: 'leads', hasFooter: false, params: null,
                      //     },
                      // );
                      setIframeKey(iframeKey + 1);
                      setShowBackBtn(false);
                    }}
                >
                  <img src={backSvg} alt="back-icon" style={{ marginRight: 10 }} />
                  {backBtn.viewAllLeads}
                </Box>
                <Typography
                  noWrap
                  style={{
                    color: '#FFFFFF',
                    fontWeight: 300,
                    fontSize: isTablet() ? '42px' : '24px',
                    lineHeight: isTablet() ? '54px' : '32px',
                    marginTop: isTablet() ? 10 : 0,
                    marginBottom: isTablet() ? 38 : 80,
                    overflowWrap: 'anywhere',
                    maxWidth: isDesktop() ? '800px' : '600px',
                    position: 'relative',
                    bottom: isTablet() ? '38px' : 0,
                  }}
                >
                  <span style={{ fontFamily: 'Montserrat-Light' }}>{`${headingWelcome}, `}</span>
                  <span style={{ fontFamily: 'Montserrat-Medium' }}>{webMenuInfo.name}</span>
                </Typography>
              </Box>
              {isDesktop() && (
                <Box mr={langCd === 'ar' ? 'unset' : '64px'} ml={langCd === 'ar' ? '64px' : 'unset'}>
                  {bodyHeaderSvg}
                </Box>
              )}
            </Box>
          </Box>
        )}

        <Box
          id="bodyContent"
          className={classes.bodyContent}
          style={{
            // eslint-disable-next-line
            height: !showFooter && !isMobile() ? (
              !isTablet() ? 'calc(100% - 160px)' : 'calc(100% - 242px)'
            ) : (
              fullScreen(menuItem) ? '100%' : classes.bodyContainer.height
            ),
            position: (isMobile() && fullScreen(menuItem)) ? 'absolute' : classes.bodyContent.position,
            top: (isMobile() && fullScreen(menuItem)) ? '0' : classes.bodyContent.top,
            width: (isMobile() && fullScreen(menuItem)) ? '100%' : classes.bodyContent.top,
            // eslint-disable-next-line
            overflow: (menuCategory && menuCategory[0] && menuCategory[0].link) ? 'hidden' : 'auto',
          }}
        >
          {(menuCategory && menuCategory[0] && menuCategory[0].link)
            ? (
              <iframe
                onLoad={() => {
                  const frameEle = document.querySelector('#appFrame');
                  if (frameEle && frameEle.contentWindow) {
                    frameEle.contentWindow.postMessage({
                      accessToken: sessionStorage.getItem('accessToken'),
                      dashboard: JSON.stringify({
                        apptFlowHeader,
                      }),
                      isWebApp: true,
                      userId: userAcct,
                      search: searchHis,
                    }, '*');
                  }
                }}
                id="appFrame"
                key={`appFrame${iframeKey}`}
                className={classes.frame}
                style={{ borderRadius: isMobile() ? 0 : 12 }}
                width="100%"
                height="100%"
                frameBorder="0"
                title="iframe"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                scrolling={menuItem === 'appointment' && !isMobile() ? 'no' : 'auto'}
                // eslint-disable-next-line
                src={document.domain === 'localhost' ? (redirectParams ? `${menuCategory[0].link.replace(domain, `http://localhost:${getLocalDebugPort(menuItem)}`)}${menuCategory[0].link.replace(domain, `http://localhost:${getLocalDebugPort(menuItem)}`).indexOf('?') > 0 ? '&' : '?'}${redirectParams}` : menuCategory[0].link.replace(domain, `http://localhost:${getLocalDebugPort(menuItem)}`)) : (redirectParams ? `${menuCategory[0].link}${menuCategory[0].link.indexOf('?') > 0 ? '&' : '?'}${redirectParams}` : menuCategory[0].link)}
              />
            )
            : (componentsMap[menuItem] && componentsMap[menuItem].component)
          }
          <Box
            className={classes.expirationBanner}
            style={{
              display: expirationBanner ? 'flex' : 'none',
            }}
          >
            <Box>
              <img src={infoWhiteSvg} alt="info_icon" />
            </Box>
            <Box>
              <Box
                component="span"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: 500,
                  fontSize: 14,
                  lineHeight: '18px',
                  marginRight: 18,
                }}
              >
                {sessionExpire.text}
              </Box>
              <Box
                component="span"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: 700,
                  fontSize: 16,
                  lineHeight: '20px',
                  cursor: 'pointer',
                  padding: 6,
                }}
                onClick={() => {
                  setCloseBanner(false);
                  setExpirationBanner(false);
                  timer.current = 1800;
                }}
              >
                {sessionExpire.button}
              </Box>
            </Box>
            <Box onClick={() => {
              setCloseBanner(true);
              setExpirationBanner(false);
            }}
            >
              <img src={cloaseWhiteSvg} alt="clase_icon" />
            </Box>
          </Box>
        </Box>
        {isMobile() && menuItem === 'home' && (
          <Box onClick={
            () => {
              dispatch({ currentPage: 'appointment' });
              handleClickMenu({
                type: 'appointment', subType: null, hasFooter: false, params: null, editPrp: null, entry: 'bottom_plus_button',
              });
            }}
          >
            <div style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
              zIndex: 999,
            }}
            >
              {newApptIcon}
            </div>
          </Box>
        )}
        {
          (showFooter && isDesktop()) && (
            <Box id="bodyFooter" className={classes.footer}>
              <Box id="footerLinks" className={classes.footerLink}>
                {links.map(({ label, url }) => (
                  <a className={classes.styledLink} key={label} href={url} id={`footer-${label}`}>
                    {label}
                  </a>
                ))}
              </Box>
              <Box id="logoFooter" className={classes.footerAvonLogo}>
                <img src={avonLogoFooter} alt="avon-logo" />
              </Box>
            </Box>
          )
        }
      </Box>
      <Modal
        icon
        color={{ borderColor: '#181818' }}
        language={langCd}
        heading={logoutDialog.heading || 'Log out?'}
        saveLabel={logoutDialog.positiveButton || 'Yes'}
        cancelLabel={logoutDialog.negativeButton || 'No'}
        submitData={() => {
          disconnect();
          sessionStorage.removeItem('accessToken');
          const idxParam = window.location.href.indexOf('?');
          const newHref = idxParam > -1
            ? window.location.href.substring(0, idxParam)
            : window.location.href;
          window.location.replace(newHref);
        }}
        iconWidth={isMobile() ? 64 : 96}
        iconHeight={isMobile() ? 64 : 96}
        open={!!logoutModal}
        closeModal={() => setLogoutModal(false)}
      />
      {changeLanguageDialog
        && (
          <Modal
            icon
            iconLabel="!"
            crossClose
            color={{ fontColor: '#F09F87', borderColor: '#F09F87' }}
            heading={changeLanguageDialog.heading || 'Language Changed'}
            body={changeLanguageDialog.body || 'This change will not impact the information you entered previously in the PRP page.'}
            saveLabel={changeLanguageDialog.positiveButton || 'OK, change language'}
            cancelLabel={changeLanguageDialog.negativeButton || 'Don\'t change'}
            submitData={changeLanguage}
            iconWidth={isMobile() ? 64 : 96}
            iconHeight={isMobile() ? 64 : 96}
            open={!!changeLanguageModal}
            closeModal={() => setChangeLanguageModal(false)}
            language={langCd}
          />
        )}
      <Modal
        icon
        color={{ borderColor: '#181818' }}
        heading={notPrpDialog.heading}
        body={notPrpDialog.body}
        saveLabel={notPrpDialog.positiveButton}
        cancelLabel={notPrpDialog.negativeButton}
        submitData={() => {
          handleClickMenu({
            type: 'personalPage', subType: 'myProfile', hasFooter: false, params: null,
          });
        }}
        iconWidth={isMobile() ? 64 : 96}
        iconHeight={isMobile() ? 64 : 96}
        open={!!notPrpModal}
        closeModal={() => setNotPrpModal(false)}
      />
      <ShareModal
        open={shareOpen}
        callApi={callApi}
        setShareOpen={setShareOpen}
        slProfile={profieJSON}
        socialList={socialList}
        sharePRPInfo={sharePRPInfo}
      />
    </Box>
  );

  // eslint-disable-next-line
  return argFetched ? (agrChecks && agrChecks.length !== 0 ? (
    <>
      {
        agrChecks[agrChecks.length - 1].agrmntTyp
        && (
          <TaC
            key={agrChecks[agrChecks.length - 1].agrmntTyp}
            agrType={agrChecks[agrChecks.length - 1].agrmntTyp}
            getAgrmntContent={getAgrmntContent}
            saveLabel={loginInfo.tcAccept || 'Accept'}
            cancelLabel={loginInfo.tcDecline || 'Decline'}
            title="title"
            submitData={async () => {
              // eslint-disable-next-line
              agrChecks.splice(agrChecks.findIndex(item => item.agrmntTyp === agrChecks[agrChecks.length - 1].agrmntTyp), 1);

              if (agrChecks.length === 0) {
                try {
                  setSubmitting(true);

                  const agrArray = [];
                  agrs.userAgrmntVers.map(a => agrArray.push(
                    {
                      agrmntTyp: a.agrmntTyp,
                      agrmntVerNr: a.latestVerNr,
                      agrmntAcptdDt: formatDate(new Date(), langCd, 'YYYY-MM-DDTHH:mm:ss'),
                      agrmntAcptdInd: true,
                    },
                  ));

                  // accept the terms and conditions
                  await callApi(acceptLegalInfo({ userAgrmnts: agrArray }));
                  setSubmitting(false);
                  return true;
                } catch (e) {
                  setError(e);
                  setSubmitting(false);
                  return false;
                }
              } else {
                return true;
              }
            }}
            isSubmitting={false}
            open={!agrChecks[agrChecks.length - 1].checked}
            closeModal={() => {
              setAgrChecks([]);
              setArgFetched(false);
              sessionStorage.removeItem('accessToken');
              const idxParam = window.location.href.indexOf('?');
              const newHref = idxParam > -1
                ? window.location.href.substring(0, idxParam)
                : window.location.href;
              window.location.replace(newHref);
            }}
          />
        )
      }
    </>
  ) : mainPage) : null;
};

Home.propTypes = {
  callApi: func.isRequired,
};

export default Home;
